import News from '@/components/News';
import Layout from '@/components/Layout';
News.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='news' >{page}</Layout>
    );
};


export async function getServerSideProps(context) {
    const UA = context.req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ));
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL || 'https://api-staging.tcom-japan.com'}/app/post/get-list-post`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    locale: context.locale

                }
            });
        const data = await res.json();
        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }
        return {
            props: { ...data.data, sign: context.locale }, // will be passed to the page component as props
        };
    } catch (error) {
        console.log(error);
        return {
            notFound: true,
        };
    }

}

export default News;


